<template>
  <tr>
    <td>
      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
            </span>
          </div>
        </v-card>
      </v-menu>

      <div>
        
        <div>
          <span class="textSecondary--text">
          RID:
          </span>
          <span class="ml-1">{{ item.archive_id }}</span>
        </div>

        <div v-if="item.batch_number" class="caption">
          <span class="textSecondary--text">
          Batch:
          </span>
          <span class="ml-1">{{ item.batch_number }}</span>
        </div>

      </div>
    </td>
    <td>
      {{ item.location === 1 ? 'Jurja Dobrile' : item.location }}
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue="item.quantity"
      :key="item.id"
      labelMode
      ></c-ms-ii>
      <!--
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
          icon
          small
          color="color1"
          v-on="on"
          @click.stop="$emit('editQuantity', item.id)"
          >
            <v-icon small>mdi-pencil-outline</v-icon>
          </v-btn>
        </template>
        <span>Edit Quantity</span>
      </v-tooltip>
      -->
    </td>
  </tr>
</template>

<script>
export default {
  props: ['item']
}
</script>